import {
  AfterContentInit,
  AfterViewInit,
  Component,
  ElementRef,
  OnDestroy,
  OnInit,
  ViewChild,
} from "@angular/core";
import { FormEditor } from "../../../bpmn.io/@bpmn-io/form-js-editor";
import { Router } from "@angular/router";
import { BaseServiceService } from "../../services/base-service.service";
import { ModalNotifyTypes } from "../modal-notify/modal-notify.component";
import translations from "../../../../customTranslate/translationsForm";
import RenderExtensionInput from "../../extension/input";
import FeedbackButtonRenderExtension from "../../extension/custom-button-files";
import selectUsuarios from "../../extension/custom-select-usuarios";
import visualizadorArchivos from "../../extension/visualizadorArchivos";
import { lastValueFrom, Observable, Subscription } from "rxjs";
import { AppData } from "../../helpers/app-data";
import { HttpClient } from "@angular/common/http";
import PropertiesPanelExtension from "../../extension/input/PropertiesPanelCustom";
import { event } from "jquery";
import DataSelector from "../../extension/data-selector";
import ExpandableTable from "../../extension/expandable-table";

declare var fabric: any;

@Component({
  selector: "app-form",
  templateUrl: "./form.component.html",
  styleUrl: "./form.component.css",
})
export class FormComponent implements OnInit, OnDestroy {
  @ViewChild("ref", { static: true }) private el: ElementRef;

  formularioObj: Formulario;
  botonProcesando = false;
  textoBotonProcesando = "Cargando...";
  formSubmitted: boolean = false;
  dialogComponentCreateFormulario: any;
  nombreFormulario: string = "";
  private currentFormIdSubscription: Subscription;
  formID: string | null = null;
  formLoaded = "";
  formParse = "";
  formEditor: any;
  isFirefox: boolean;
  private readonly schema = {
    schemaVersion: 1,
    exporter: {
      name: "form-js",
      version: "0.1.0",
    },
    components: [],
    type: "default",
  };

  constructor(
    private elRef: ElementRef,
    private baseService: BaseServiceService,
    private router: Router,
    private http: HttpClient
  ) {
    this.formularioObj = new Formulario();
  }

  ngOnInit(): void {
    this.baseService.exportVisibleTablaArchivos(false);
    
    
    const container = document.querySelector("#form");
    const targetNode = container;
    
    // Bandera para controlar si ya se hizo la traducción inicial
    

   

    this.formEditor = new FormEditor({
        container: container,
        keyboard: { bindTo: document },
        additionalModules: [
            RenderExtensionInput,
            FeedbackButtonRenderExtension,
            selectUsuarios,
            PropertiesPanelExtension,
            visualizadorArchivos,
            DataSelector,
            ExpandableTable
        ],
    });

   
    

    this.currentFormIdSubscription = this.baseService.currentFormId.subscribe(
        (formId) => {
            this.formID = formId;
            this.getFormConfig().subscribe((response) => {
                this.formLoaded = response.Data.Configuracion;
                this.nombreFormulario = response.Data.Nombre;
                
                const importSchema = (schema: any) => {
                    this.formEditor.importSchema(schema)
                        .then(() => {
                            // Remover elementos específicos una vez que el esquema se ha importado
                            
                        })
                        .catch(err => console.error("Schema import failed:", err));
                };

                if (!this.formLoaded || this.formLoaded === "") {
                    try {
                        importSchema(this.schema);
                    } catch (err) {
                        console.error("Importing default schema failed:", err);
                    }
                } else {
                    try {
                        this.formParse = JSON.parse(this.formLoaded);
                        importSchema(this.formParse);
                    } catch (err) {
                        console.error("Parsing or importing form failed:", err);
                    }
                }
            }, error => {
                console.error("Error getting form config:", error);
            });
        }
    );

    this.initializeFabric();

    
  }

  initializeFabric() {
    var CommandBarElements = document.querySelectorAll(".ms-CommandBar");
    for (var i = 0; i < CommandBarElements.length; i++) {
      new fabric["CommandBar"](CommandBarElements[i]);
    }

    // var DropdownHTMLElements = document.querySelectorAll(".ms-Dropdown");
    // for (var i = 0; i < DropdownHTMLElements.length; ++i) {
    //   var Dropdown = new fabric["Dropdown"](DropdownHTMLElements[i]);
    // }

    var DatePickerElements = document.querySelectorAll(".ms-DatePicker-holder");
    for (var i = 0; i < DatePickerElements.length; i++) {
      new fabric["DatePicker"](DatePickerElements[i]);
    }

    var SpinnerElements = document.querySelectorAll(".ms-Spinner");
    for (var i = 0; i < SpinnerElements.length; i++) {
      new fabric["Spinner"](SpinnerElements[i]);
    }
  }

  getFormConfig(): Observable<any> {
    return this.http.get<any>(
      `${AppData.API_URL}Formulario/GetFormularioConfiguracion?Id=${this.formID}`
    );
  }
  ngOnDestroy(): void {
    this.currentFormIdSubscription.unsubscribe();
  }

  translateComponents(): Promise<void> {
    return new Promise((resolve) => {
      const elementsToTranslate = document.querySelectorAll(
        ".fjs-palette-field-text"
      );
      const elementsToTranslateTitles = document.querySelectorAll(
        ".fjs-palette-group-title"
      );
      const elementsToTranslateComponent = document.querySelectorAll(
        ".fjs-palette-header"
      );
      const elementsToTranslateButtons =
        document.querySelectorAll(".fjs-palette-field");

      // Cambiar la visibilidad a hidden antes de la traducción
      elementsToTranslate.forEach((element) => {
        element.classList.add("hidden-text");
      });
      elementsToTranslateTitles.forEach((element) => {
        element.classList.add("hidden-text");
      });
      elementsToTranslateComponent.forEach((element) => {
        element.classList.add("hidden-text");
      });
      elementsToTranslateButtons.forEach((element) => {
        element.classList.add("hidden-text");
      });
      
      // Realizar las traducciones
      elementsToTranslate.forEach((element) => {
        const originalText =
          element.getAttribute("data-original-text") ||
          element.textContent?.trim();
        const translatedText = translations[originalText];
        if (translatedText) {
          element.setAttribute("data-original-text", originalText!);
          element.textContent = translatedText;
        }
      });

      elementsToTranslateButtons.forEach((element) => {
        const originalDataFieldType = element.getAttribute("data-field-type");
        const translatedDataFieldType = translations[originalDataFieldType];
        if (translatedDataFieldType) {
          element.setAttribute("data-field-type", translatedDataFieldType);
        }

        const originalTitle =
          element.getAttribute("data-original-title") ||
          element.getAttribute("title");
        const translatedTitle = translations[originalTitle];
        if (translatedTitle) {
          element.setAttribute("data-original-title", originalTitle!);
          element.setAttribute("title", translatedTitle);
        }
      });

      elementsToTranslateTitles.forEach((element) => {
        const originalText =
          element.getAttribute("data-original-text") ||
          element.textContent?.trim();
        const translatedText = translations[originalText];
        if (translatedText) {
          element.setAttribute("data-original-text", originalText!);
          element.textContent = translatedText;
        }
      });

      elementsToTranslateComponent.forEach((element) => {
        const originalText =
          element.getAttribute("data-original-text") ||
          element.textContent?.trim();
        const translatedText = translations[originalText];
        if (translatedText) {
          element.setAttribute("data-original-text", originalText!);
          element.textContent = translatedText;
        }
      });

      const inputElement = document.querySelector(".fjs-palette-search");
      if (inputElement) {
        const originalPlaceholder =
          inputElement.getAttribute("data-original-placeholder") ||
          inputElement.getAttribute("placeholder");
        const translatedPlaceholder = translations[originalPlaceholder];
        if (translatedPlaceholder) {
          inputElement.setAttribute(
            "data-original-placeholder",
            originalPlaceholder!
          );
          inputElement.setAttribute("placeholder", translatedPlaceholder);
        }
      }

      const h2Element = document.querySelector(".fjs-empty-editor-card h2");
      if (h2Element) {
        const originalText =
          h2Element.getAttribute("data-original-text") ||
          h2Element.textContent?.trim();
        const translatedText = translations[originalText];
        if (translatedText) {
          h2Element.setAttribute("data-original-text", originalText!);
          h2Element.textContent = translatedText;
        }
      }

      const spanElements = document.querySelectorAll(
        ".fjs-empty-editor-card span"
      );
      spanElements.forEach((spanElement) => {
        const originalText =
          spanElement.getAttribute("data-original-text") ||
          spanElement.textContent?.trim();
        const translatedText = translations[originalText];
        if (translatedText) {
          spanElement.setAttribute("data-original-text", originalText!);
          spanElement.textContent = translatedText;
        }
      });

      // Restaurar la visibilidad después de la traducción
      elementsToTranslate.forEach((element) => {
        element.classList.remove("hidden-text");
      });
      elementsToTranslateTitles.forEach((element) => {
        element.classList.remove("hidden-text");
      });
      elementsToTranslateComponent.forEach((element) => {
        element.classList.remove("hidden-text");
      });
      elementsToTranslateButtons.forEach((element) => {
        element.classList.remove("hidden-text");
      });

      resolve();
    });
  }

  translateAddedNodes(): Promise<void> {
    return new Promise((resolve) => {
      const elementsToTranslatePanelLabel = document.querySelectorAll(
        ".bio-properties-panel-label"
      );
      const elementsToTranslatePanelDescription = document.querySelectorAll(
        ".bio-properties-panel-description"
      );
      const elementsToTranslatePanelHeader = document.querySelectorAll(
        ".bio-properties-panel-header-label"
      );
      const elementsToTranslatePanelTooltip = document.querySelectorAll(
        ".bio-properties-panel-tooltip-content"
      );

      // Cambiar la visibilidad a hidden antes de la traducción

      elementsToTranslatePanelLabel.forEach((element) => {
        const originalText =
          element.getAttribute("data-original-text") ||
          element.textContent!.trim();
        const translatedText = translations[originalText];
        if (translatedText) {
          element.setAttribute("data-original-text", originalText);
          element.textContent = translatedText;
        }
      });

      elementsToTranslatePanelDescription.forEach((element) => {
        const originalText =
          element.getAttribute("data-original-text") ||
          element.textContent!.trim();
        const translatedText = translations[originalText];
        if (translatedText) {
          element.setAttribute("data-original-text", originalText);
          element.textContent = translatedText;
        }
      });

      elementsToTranslatePanelTooltip.forEach((element) => {
        const originalText =
          element.getAttribute("data-original-text") ||
          element.textContent!.trim();
        const translatedText = translations[originalText];
        if (translatedText) {
          element.setAttribute("data-original-text", originalText);
          element.textContent = translatedText;
        }
      });

      resolve();
    });
  }

  invalidField(fieldName: string): boolean {
    const fieldValue = this.formularioObj[fieldName as keyof Formulario];

    // Verificar si el campo está definido y no es nulo
    if (fieldValue !== undefined && fieldValue !== null) {
      // Si es un string, verificar si está vacío o solo contiene espacios en blanco
      if (typeof fieldValue === "string") {
        return this.formSubmitted && !fieldValue.trim();
      }
      // Si es un número, verificar si es NaN (Not a Number)
      else if (typeof fieldValue === "number") {
        return this.formSubmitted && isNaN(fieldValue);
      }
      // Otros tipos de datos no se consideran inválidos
      else {
        return false;
      }
    }
    // Si el campo es undefined o null, considerarlo inválido
    else {
      return this.formSubmitted;
    }
  }

  validateFormulario() {
    this.formSubmitted = true;
    return !["Nombre", "Descripcion", "Estado", "Version"].some((field) =>
      this.invalidField(field)
    );
  }

  clearFormFormulario() {
    this.formularioObj = new Formulario();

    this.baseService.clearForm();
  }

  abrirModalGuardarFormulario() {
    const dialog = document.querySelector(".guardar-formulario");
    this.dialogComponentCreateFormulario = new fabric["Dialog"](dialog);
    this.dialogComponentCreateFormulario.open();
  }

  async crearFormulario() {
    this.validateFormulario();
    if (this.validateFormulario()) {
      this.botonProcesando = true;
      try {
        const schema = this.formEditor.saveSchema(this.schema);
        const config = JSON.stringify(schema);
        this.formularioObj.Configuracion = config;
        this.formularioObj.Estado = parseInt(this.formularioObj.Estado as any);
        // Luego continuar con el resto de lógica de creación de Proceso...
      } catch (error) {
        // Manejar cualquier error que ocurra al guardar el XML
        console.error("Error al guardar el XML:", error);
        this.botonProcesando = false;
        return;
      }

      try {
        const response = await this.baseService.create(
          "Formulario/CrearFormulario",
          this.formularioObj
        );

        if (!response.Ok) {
          this.dialogComponentCreateFormulario.close();

          let mensajeError = "<ul>";
          response.ValidationErrors.forEach((error: any) => {
            mensajeError += `<li>${error}</li>`;
          });
          mensajeError += "</ul>";

          this.baseService.triggerShowModal(
            "Error al crear Formulario",
            mensajeError,
            ModalNotifyTypes.Danger,
            false
          );
          this.botonProcesando = false;
        } else {
          this.dialogComponentCreateFormulario.close();

          var example = document.querySelector(".success");

          var dialog = example!.querySelector(".modal-succes");

          var dialogComponent = new fabric["Dialog"](dialog);

          dialogComponent.open();
          /* this.baseService.triggerShowModal(
            'Proceso Creado',
            'Se ha almacenado el registro correctamente ',
            ModalNotifyTypes.Success,
            false
          ); */
          this.botonProcesando = false;
          this.clearFormFormulario();
        }
      } catch (error: any) {
        this.dialogComponentCreateFormulario.close();

        let mensajeError = error.error.Error;

        this.baseService.triggerShowModal(
          "Error",
          mensajeError,
          ModalNotifyTypes.Danger,
          false
        );
        this.botonProcesando = false;
      }
    } else {
      this.botonProcesando = false;
    }
  }

  abrirModalCrear() {
    this.clearFormFormulario();
    const dialog = document.querySelector(".create-formulario");
    this.dialogComponentCreateFormulario = new fabric["Dialog"](dialog);
    this.dialogComponentCreateFormulario.open();
  }
  abrirDatatable() {
    this.router.navigate(["home/formularios"]);
  }

  async actualizarFormulario() {
    this.botonProcesando = true;
    try {
      const schema = this.formEditor.saveSchema(this.formParse);
      console.log(schema);
      const config = JSON.stringify(schema);
      console.log(config);
      
      this.formularioObj.Configuracion = config;
    } catch (error) {
      console.error("Error al guardar el XML:", error);
      this.botonProcesando = false;
      return;
    }
    
    console.log("Antes de enviar la petición");
    
    try {
      // Elimina el pipe y catchError, y maneja el error directamente con try/catch
      const response = await lastValueFrom(this.http.post<any>(
        AppData.API_URL+"Formulario/ActualizarFormularioConfiguracion?Id=" + Number(this.formID),
        this.formularioObj
      ));
      
      console.log("Respuesta recibida:", response);
      
      if (!response.Ok) {
        this.dialogComponentCreateFormulario.close();
        console.log('entra al err');
        let mensajeError = "<ul>";
        response.ValidationErrors.forEach((error: any) => {
          mensajeError += `<li>${error}</li>`;
        });
        mensajeError += "</ul>";
        this.baseService.triggerShowModal(
          "Error al actualizar Formulario",
          mensajeError,
          ModalNotifyTypes.Danger,
          false
        );
        this.botonProcesando = false;
      } else {
        var example = document.querySelector(".editado");
        var dialog = example!.querySelector(".editar-formulario");
        var dialogComponentEditarForm = new fabric["Dialog"](dialog);
        dialogComponentEditarForm.open();
       
        this.botonProcesando = false;
      }
    } catch (error) {
     
      this.baseService.triggerShowModal(
        "Error",
        error.error.Error,
        ModalNotifyTypes.Danger,
        false
      );
      this.botonProcesando = false;
    }
  }
}

export class Formulario {
  Nombre: string;
  Descripcion: string;
  Estado: number | null;
  Version: number | null;
  Configuracion: string;
  /*   UsuariosPermitidos: string;
  RolesPermitidos: string;
  GruposPermitidos: string; */
  TodosUsuarios: boolean;
  Activo: boolean;

  constructor() {
    this.Nombre = "";
    this.Descripcion = "";
    this.Estado = null;
    this.Version = null;
    this.Configuracion = "";
    /*     this.UsuariosPermitidos = '';
    this.RolesPermitidos = '';
    this.GruposPermitidos = ''; */
    this.TodosUsuarios = false;
    this.Activo = false;
  }
}
